<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useAgenticSearchStore } from '@/search/agentic_search.store'
import { gradeLabel } from '@/util/gradesort'

const emit = defineEmits<{ refineSearch: [] }>()

const { latestSearch } = storeToRefs(useAgenticSearchStore())

const uploadedFileName = computed(() => latestSearch.value.files[0]?.name ?? '')

// The wizard stores its chosen grades as one comma-separated string.
const searchedGrades = computed(() => {
  const grades = (latestSearch.value.searchGrade ?? '').split(',').map((grade) => grade.trim()).filter(Boolean)
  return grades.map(gradeLabel).join(', ')
})

const hasSearchMetadata = computed(() => Boolean(uploadedFileName.value || searchedGrades.value))
</script>

<template>
  <div v-if="latestSearch.prompt" class="ai-border !border my-4 px-6 py-4">
    <div class="mb-2 flex items-center justify-between gap-3">
      <span class="text-md font-bold uppercase leading-none tracking-[0.5px] text-[#555555]">You searched for</span>
      <button
        type="button"
        class="inline-flex h-8 items-center whitespace-nowrap rounded-xs border border-gray-400 bg-white px-4 text-md font-medium leading-none text-gray-900 hover:border-gray-600 hover:bg-[#f5f5f5]"
        aria-label="Edit search in Assessment Wizard"
        @click="emit('refineSearch')"
      >
        Edit search
      </button>
    </div>
    <div class="mb-3 break-words text-lg leading-6 text-gray-900">{{ latestSearch.prompt }}</div>
    <div v-if="hasSearchMetadata" class="mt-2 flex items-center gap-4 text-md leading-5 text-[#555555]">
      <span v-if="uploadedFileName" class="flex max-w-[300px] items-center gap-1.5">
        <span class="material-icons flex-shrink-0 text-[16px] leading-none" aria-hidden="true">description</span>
        <span class="truncate">{{ uploadedFileName }}</span>
      </span>
      <span v-if="searchedGrades">Searched {{ searchedGrades }}</span>
    </div>
  </div>
</template>
